import './view.scss';
import Splide from '@splidejs/splide';
import { Intersection } from '@splidejs/splide-extension-intersection';


function teamSliderSplide() {
    let teamSlider = document.getElementsByClassName('content-slider__items');
    if (teamSlider.length > 0) {
        let options = {
            gap: 0,
            arrows: true,
            pagination: false,
            type: 'slide',
            fixedWidth: '25%',
            perMove: 4,
            autoplay: 'pause',
            intersection: {
                inView: {
                    autoplay: true,
                },
                outView: {
                    autoplay: false,
                },
            },
            speed: 1000,
            breakpoints: {
                390: {
                    fixedWidth: '70%',
                    perMove: 1,
                },
                600: {
                    fixedWidth: '55%',
                    perMove: 1,
                },
                767: {
                    fixedWidth: '40%',
                    perMove: 2,
                },
                992: {
                    fixedWidth: '30%',
                    perMove: 3,
                },
                1400: {
                    fixedWidth: '27%',
                    perMove: 3,
                }
            }

        };
        for (let i = 0; i < teamSlider.length; i++) {
            let splide = new Splide(teamSlider[i], options);

            splide.on('overflow', function (isOverflow) {
                splide.options = {
                    drag: isOverflow
                };
            });

            splide.mount({Intersection});
        }
    }
}

document.addEventListener('DOMContentLoaded', function () {
    if (document.getElementsByClassName('content-slider').length > 0) {
        teamSliderSplide();
    }
});